import { render, staticRenderFns } from "./LeftButtons.vue?vue&type=template&id=0a1b177e&"
import script from "./LeftButtons.vue?vue&type=script&lang=js&"
export * from "./LeftButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports